"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _lcHttp = _interopRequireDefault(require("lc-http"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var SmartyStreetsService = /*#__PURE__*/(0, _createClass2.default)(function SmartyStreetsService(config) {
  var _this = this;
  (0, _classCallCheck2.default)(this, SmartyStreetsService);
  (0, _defineProperty2.default)(this, "getSuggestions", function (input) {
    var params = {
      'auth-id': _this.authId,
      max_results: _this.suggestions,
      search: input.value
    };
    return (0, _lcHttp.default)({
      url: _this.suggestionURL,
      params: params,
      useCsrf: false
    });
  });
  (0, _defineProperty2.default)(this, "validateAddressIsResidential", function (streetProps) {
    var params = _objectSpread({
      'auth-id': _this.authId,
      'auth-token': _this.authToken
    }, streetProps);
    return (0, _lcHttp.default)({
      url: _this.streetAddressURL,
      params: params,
      useCsrf: false
    }).then(function (response) {
      if (response && Array.isArray(response.data) && response.data.length > 0) {
        var _response$data;
        var data = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data[0];
        var validation = {
          record_type: data.metadata.record_type,
          rdi: data.metadata.rdi,
          zip_type: data.metadata.zip_type,
          dpv_match_code: data.analysis.dpv_match_code,
          dpv_cmra: data.analysis.dpv_cmra
        };
        var validsRecordTypes = ['F', 'H', 'S'];
        var validDpvMatchCodes = ['Y', 'S', 'D'];
        var isResidential = validation.rdi === 'Residential';
        var isZipStandard = validation.zip_type === 'Standard';
        var isRecordTypeValid = validsRecordTypes.includes(validation.record_type);
        var isDpvMatchValid = validDpvMatchCodes.includes(validation.dpv_match_code);
        var isDpvCmraValid = validation.dpv_cmra === 'N';
        var isValidResidential = {
          isValid: isResidential && isZipStandard && isRecordTypeValid && isDpvMatchValid && isDpvCmraValid
        };
        return isValidResidential;
      }
      return false;
    }).catch(function (error) {
      throw new Error(error.message);
    });
  });
  this.authId = config.authId;
  this.suggestions = config.suggestions;
  this.suggestionURL = config.suggestionURL;
  this.streetAddressURL = config.streetAddressURL;
  this.authToken = config.authToken;
});
var _default = SmartyStreetsService;
exports.default = _default;
require('/var/lib/jenkins/workspace/pf-yts-ui_Release_0/node_modules/pf-address-service/dist/pf-address-service.scss');